export default __webpack_public_path__ + "static/media/BCA21.bd112f8f.jpg";